import { mobile as mobileCheck } from 'dibs-client-check';
import Cookies from 'js-cookie';
import { deepLinkSupported } from '../../../mobileAds/helpers/deeplink';
import { isPlaReferrer } from './referrerHelper';
const hasInterstitualCookie = () => Cookies.getJSON().dibsMobileInterstitial || undefined;

export const shouldShowAd = () => {
    const isAppPage = mobileCheck.iPhone() && !hasInterstitualCookie() && deepLinkSupported();
    return isAppPage && !isPlaReferrer();
};
